import {
  Box,
  HStack,
  Image,
  Center,
  Text,
  Button,
  VStack,
} from '@chakra-ui/react';

import { TaskCommentWithReplies } from '../../../models';
import { extractName, timeSince } from '../../../utils';
import { MentionedName } from '../../../components';
import ReplyIcon from '../../../assets/tasks/reply.svg';
import { useState } from 'react';
import { NewCommentInput } from '.';

export const TaskThread = ({
  taskComment: {
    id,
    content,
    createdBy: { profilePictureThumbnailURL, firstName, lastName },
    createdAt,
    replies,
  },
  isDisabled,
  onAddNewReply,
}: {
  taskComment: TaskCommentWithReplies;
  isDisabled: boolean;
  onAddNewReply: (reply: string, parentId?: number) => void;
}) => {
  const [showInput, setShowInput] = useState(false);

  return (
    <Box>
      <HStack justify="start" w="full" mb="2">
        <Box w="8" h="8" bg="custom_blue.1" borderRadius="full">
          {profilePictureThumbnailURL ? (
            <Image src={profilePictureThumbnailURL} borderRadius="full" />
          ) : (
            <Center h="full" color="white" textTransform="capitalize">
              {extractName(`${firstName} ${lastName}`)}
            </Center>
          )}
        </Box>

        <Text color="#334253" fontWeight="medium" fontSize="sm">
          {firstName} {lastName}
        </Text>
      </HStack>

      <Text w="full" color="#67727E" fontWeight="medium" fontSize="sm">
        <MentionedName text={content} />
      </Text>

      <HStack justify="space-between" my="2">
        <Button
          onClick={() => setShowInput(true)}
          bg="transparent"
          _hover={{ bg: 'transparent' }}
          color="#4A4F5C"
          fontSize="sm"
          fontWeight="medium"
          p="0"
          h="fit-content"
        >
          <Image src={ReplyIcon} alt="reply icon" mr="2" />
          Reply
        </Button>

        <Text color="#67727E" fontWeight="medium" fontSize="xs">
          {timeSince(createdAt)}
        </Text>
      </HStack>

      {showInput && (
        <Box mt="6">
          <NewCommentInput
            isDisabled={isDisabled}
            onSubmit={reply => {
              onAddNewReply(reply, id);
              setShowInput(false);
            }}
          />
        </Box>
      )}

      {replies?.length ? (
        <Box px="3" py="3">
          <VStack align="stretch" px="3" gap="4" borderLeft="2px solid #E9EBF0">
            {replies.map(reply => (
              <TaskThread
                taskComment={{ ...reply, id }}
                key={reply.id}
                isDisabled={isDisabled}
                onAddNewReply={onAddNewReply}
              />
            ))}
          </VStack>
        </Box>
      ) : null}
    </Box>
  );
};
